const theme = {
  // based on typical browser default font size of 16px
  breakpoints: {
    xs: "320px",
    s: "414px",
    m: "768px",
    lg: "1024px",
    xl: "1440px", // Used as the max-width
  },
  variables: {
    maxPageWidth: "1504px", // xl breakpoint (1440px) + 72px (2rem padding on each side)
    navHeight: "140px",
    subNavHeight: "3.25rem",
    navBannerHeightDesktop: "140px", // 76px + 58px
    navBannerHeightTablet: "159px", // 76px + 83px
    navBannerHeightMobile: "184px", // 76px + 108px
    navSubNavHeightDesktop: "134px", // 76px + 58px
    navSideNavHeightMobile: "140px", // 76px + 64px
    logoHeight: "84px",
    logoWidth: "392px",
  },
  colors: {
    primary: "#3672af",
    primary700: "#1A3F63",
    primary500: "#7495C4",
    misc600: "#656565",
    misc700: "#555555",
    misc800: "#1B1B1B",
    secondary: "#F6C255",
    grey300: "#F6F5F4",
    grey200: "#F8F8F8",
    white: "#ffffff",
    blue500: "#3570AC",
    blue700: "#204367",
  },
  fontSizes: {
    h1: "3.125rem",
    h2: "3rem",
    h3: "1.875",
    h4: "1.25rem",
    h5: "1.125rem",
    xs: "0.75rem", // 12px
    s: "0.875rem", // 14px
    m: "1rem", // 16px
    r: "1.125rem", // 18px
    l: "1.5rem", // 24px
    xl: "2rem", // 32px
  },
};
export default theme;
